import { tss } from '../../ds/components'

export const useDisabledStyles = tss.create(() => ({
    // eslint-disable-next-line tss-unused-classes/unused-classes
    disabled: {
        WebkitFilter: 'grayscale(1)',
        MozFilter: 'grayscale(1)',
        MSFilter: 'grayscale(1)',
        OFilter: 'grayscale(1)',
        filter: 'grayscale(1)',
        pointerEvents: 'none',
        '& > *': {
            opacity: 0.75,
        },
    },
}))
